import React, { useRef, useState, useEffect } from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import speakerIcon from '../../images/event/speaker.png'
import agendaIcon from '../../images/event/agenda.png'
import Axios from 'axios'
import { toast } from 'react-toastify'
import config from '../../config'
import { useDispatch } from 'react-redux'
import ProgrammeListing from '../ProgrammeListing';

const StyledModal = styled(Modal)`
  text-align: center;
  color: #002060;

  .modal-dialog {
    min-width: 75%;
  }
  .modal-content {
    background-color: rgba(255, 255, 255, 1);
    border: none;
    border-radius: 0;
    padding: 24px 36px;
    margin-bottom: 24px;

    .modal-header {
      color: #FFAD2C;
      border: none;
      text-align: left;
      .modal-title {
        font-size: 36px;
        font-weight: bold;
        font-style: italic;
      }
      button {
        font-size: 36px;
        opacity: 1;
        color: rgba(0, 0, 0, 0.55);
      }
    }
    .header-section {

      .navigation {
        height: 100%;
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        button {
          background: linear-gradient(#FF9821, #F83636);
          color: white;
          border: 2px solid #FF9821;
          border-radius: 12px;
          padding: 6px 16px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          h5 {
            margin: 0 4px;
          }
          &:hover {
            background: #FF9821;
          }
        }
      }
    }
    .divider {
      background: #002060;
      height: 4.5px;
      margin: 32px 0;
    }
  }
  .back-top {
    border: none;
    border-radius: 12px;
    background: linear-gradient(#FF9821, #F83636);
    position:absolute;
    bottom: 0;
    right: 0;
    svg {
      width:50;
      height:50;
    }
  }
  .modal-body {
    padding-bottom: 36px;
  }
  .agenda {
    button {
      margin: 0 16px;
      background: #F87949;
      border: 2px solid #FF9821;
      font-weight: 500;
      border-radius: 12px;
      padding: 4px 12px;
      color: white;
      font-size: 16px;
    }
    .active {
      font-style: italic;
      color: #002060;
      text-decoration: underline;
    }
  }
  .image {
    height: 184px;
    width: 184px;
    transition: 100ms linear;
    background-position: center;
    background-size: cover;
  }
  h5.speaker-name {
    font-size: 15px;
    font-weight: 600;
    color:#0c6bae;
  }
  .speaker-title {
    font-size: 24px;
    color: #426fa8;
    font-weight: bold;
  }
  #agenda-container {
    width: 80%;
    margin: 0 auto;
    header {
      font-size: 24px;
      button {
        padding: 6px 16px;
      }
    }
    section {
      text-align: left;
      font-size: 18px;
    }
  }
`

export default function ProgrammeModal({ showModal, hideModal }) {
  const speakerSec = useRef()
  const agendaSec = useRef()
  const startModal = useRef()

  const dispatch = useDispatch()
  const [ lectureHall, setLectureHall ] = useState(1)
  const [ loading, setLoading ] = useState(false)
  const [ members, setMembers ] = useState([])


  const scrollTop = (ref) =>{
    ref.current.scrollIntoView({ behavior: 'smooth' })
  };
  useEffect(() => {
    Axios
      .get(`${config.apiUrl}/api/faculty_members`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success){
          setMembers(data.members)
          setLoading(false)
        }
      })
      .catch((err) => {
        setLoading(false)
        toast("Something went wrong. Please try again later.")
        console.error('Error: ', err)
      })
  }, [])

  return (
    <StyledModal
      show={showModal}
      onHide={hideModal}
      size="xl"
      aria-labelledby="menu-modal"
      centered
    >
      <Modal.Header closeButton>
        <span ref={startModal}></span>
      </Modal.Header>
      <Modal.Body>
        <Row className="header-section" noGutters>
          <div className="navigation">
            <button onClick={()=>scrollTop(agendaSec)}>
              <img src={agendaIcon} width="24" alt="nav"/>
              <h5>Agenda</h5>
            </button>
            <button onClick={()=>scrollTop(speakerSec)}>
              <img src={speakerIcon} width="24" alt="nav"/>
              <h5>Speakers</h5>
            </button>
          </div>
        </Row>
        <span ref={agendaSec}></span>
        <div className="divider"></div>

        <div className="agenda">
          <button className={`${lectureHall === 1 && 'active'}`} onClick={()=>setLectureHall(1)}>Lecture Hall A</button>
          <button className={`${lectureHall === 2 && 'active'}`} onClick={()=>setLectureHall(2)}>Lecture Hall B</button>
        </div>

        <div id="agenda-container">
          <ProgrammeListing hallNumber={lectureHall} />
        </div>

        <div className="divider"></div>

        <div className="container">
          <div ref={speakerSec}></div>
          <p className="speaker-title">Speakers</p>
          <Row noGutters className="align-items-start">
            {members && members.map(speaker=>(
              <Col sm={3} key={`programme-${speaker.id}`}>
                <div className="image mb-2 mx-auto img-fluid rounded-circle" style={{backgroundImage: `url(${speaker.image.url})`}}></div>
                <h5 className="speaker-name">{speaker.honorific}</h5>
                <h5 className="speaker-name">{speaker.fullName}</h5>
              </Col>
            ))}
          </Row>
        </div>
        <button onClick={()=>scrollTop(startModal)} className="back-top">
          <svg width="45" height="45" viewBox="0 0 45 45">
            <g transform="translate(-1767 -3747)">
              <g transform="translate(120 -2428)">
                <path d="M22.175,9.358a1.43,1.43,0,0,0-1.43-1.43H5.063l5.813-5.42A1.43,1.43,0,1,0,8.923.421L.455,8.311a1.43,1.43,0,0,0,0,2.091L8.923,18.3A1.43,1.43,0,1,0,10.875,16.2L5.063,10.788H20.746A1.43,1.43,0,0,0,22.175,9.358Z" transform="translate(1678.681 6187) rotate(90)" fill="#fff"/>
              </g>
            </g>
          </svg>
        </button>
      </Modal.Body>
    </StyledModal>
  )
}
